<template>
  <div class="update-field">
    <p class="update-field__title h2">Редактирование площадки</p>

    <AppMenu
      v-model="activeMenuItem"
      :items="menuItems"
    />

    <KeepAlive>
      <component
        :is="componentName"
        class="update-field__content"
      />
    </KeepAlive>
  </div>
</template>

<script>
import AppMenu from '@/components/AppMenu'
import AppInformation from './components/AppInformation'
import AppSchedule from './components/AppSchedule'
import AppMap from './components/AppMap'
import AppPhotoUpload from './components/AppPhotoUpload'

export default {
  name: 'index',
  components: {
    AppMenu,
    AppInformation,
    AppSchedule,
    AppMap,
    AppPhotoUpload
  },
  data () {
    return {
      menuItems: [
        { value: 'information', label: 'Информация', component: 'AppInformation' },
        { value: 'schedule', label: 'График работы', component: 'AppSchedule' },
        { value: 'map', label: 'Местоположение', component: 'AppMap' },
        { value: 'images', label: 'Фотографии', component: 'AppPhotoUpload' }
      ],
      activeMenuItem: 'information'
    }
  },
  computed: {
    componentName () {
      return this.menuItems
        .find(item => item.value === this.activeMenuItem).component
    }
  }
}
</script>

<style lang="scss" scoped>
.update-field {
  &__title {
    margin-bottom: 14px;
  }

  &__content {
    margin-top: 30px;
  }
}
</style>
